import getUnixDate from './get-unix-date';

export { getUnixDate };

export default getUnixDate;
